(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6367],{

/***/ 74004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esg-guide/blog/make",
      function () {
        return __webpack_require__(35876);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_esg_guide_blog_Esg_guide_blog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15603);
/* harmony import */ var _components_esg_guide_Esg_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28680);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32511);
/* harmony import */ var _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44027);






var BlogPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            parent: "\uD648",
            sub: "ESG\uC790\uB8CC\uC2E4",
            subTitle: "\uC81C\uC791\uC0AC\uB840 & \uD3EC\uC7A5\uC7AC\uB9AC\uBDF0",
            pageTitle: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_5__/* .SeoMeta.caseStudiesAndPackagingReviews.title */ .e.caseStudiesAndPackagingReviews.title,
            pageDesc: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_5__/* .SeoMeta.caseStudiesAndPackagingReviews.description */ .e.caseStudiesAndPackagingReviews.description,
            pageKeyword: _utils_seo_SeoMeta__WEBPACK_IMPORTED_MODULE_5__/* .SeoMeta.caseStudiesAndPackagingReviews.keywords */ .e.caseStudiesAndPackagingReviews.keywords,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_esg_guide_Esg_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                blogMenu: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_esg_guide_blog_Esg_guide_blog__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    blogMenu: 1
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,8680,5603,9774,2888,179], function() { return __webpack_exec__(74004); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);